/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssumptionEntityTypeAssocRequest } from '../model';
// @ts-ignore
import { EntityOrderMap } from '../model';
// @ts-ignore
import { EntityType } from '../model';
// @ts-ignore
import { EntityTypeFeatureWithStorageType } from '../model';
/**
 * EntityTypeApi - axios parameter creator
 * @export
 */
export const EntityTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary creates a single entityType
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityType: async (data?: EntityType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary enable/disable a single entityType
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableEntityType: async (id: number, enabled: boolean, version?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableEntityType', 'id', id)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('enableEntityType', 'enabled', enabled)
            const localVarPath = `/navigator/entityTypes/{id}/enabled/{enabled}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"enabled"}}`, encodeURIComponent(String(enabled)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEntityTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountByEntityType: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEntityCountByEntityType', 'id', id)
            const localVarPath = `/navigator/entityTypes/{id}/entities/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityType: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEntityType', 'id', id)
            const localVarPath = `/navigator/entityTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets the entity type features available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypeFeatures: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets the time frame for an entity type.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSeriesTimeFrame: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTimeSeriesTimeFrame', 'id', id)
            const localVarPath = `/navigator/entityTypes/{id}/timeSeriesSubEntityTimeFrame`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {{ [key: string]: number; }} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAdminEntityTypes: async (entities?: { [key: string]: number; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entities, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {Array<EntityOrderMap>} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderEntityTypes: async (entities?: Array<EntityOrderMap>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entities, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates assumption entity type associations
         * @param {number} entityType 
         * @param {AssumptionEntityTypeAssocRequest} [assumptionEntityTypeAssocRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssumptionEntityTypeAssocs: async (entityType: number, assumptionEntityTypeAssocRequest?: AssumptionEntityTypeAssocRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('updateAssumptionEntityTypeAssocs', 'entityType', entityType)
            const localVarPath = `/navigator/entityTypes/admin/entityTypes/{entityType}/assumptions/associate`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assumptionEntityTypeAssocRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updates a single entityType
         * @param {number} id 
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityType: async (id: number, data?: EntityType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEntityType', 'id', id)
            const localVarPath = `/navigator/entityTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityTypeApi - functional programming interface
 * @export
 */
export const EntityTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary creates a single entityType
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEntityType(data?: EntityType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEntityType(data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary enable/disable a single entityType
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableEntityType(id: number, enabled: boolean, version?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableEntityType(id, enabled, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminEntityTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminEntityTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCountByEntityType(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCountByEntityType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityType(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets the entity type features available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTypeFeatures(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityTypeFeatureWithStorageType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTypeFeatures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityTypes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets the time frame for an entity type.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeSeriesTimeFrame(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeSeriesTimeFrame(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {{ [key: string]: number; }} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderAdminEntityTypes(entities?: { [key: string]: number; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderAdminEntityTypes(entities, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {Array<EntityOrderMap>} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderEntityTypes(entities?: Array<EntityOrderMap>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityOrderMap>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderEntityTypes(entities, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates assumption entity type associations
         * @param {number} entityType 
         * @param {AssumptionEntityTypeAssocRequest} [assumptionEntityTypeAssocRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssumptionEntityTypeAssocs(entityType: number, assumptionEntityTypeAssocRequest?: AssumptionEntityTypeAssocRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssumptionEntityTypeAssocs(entityType, assumptionEntityTypeAssocRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updates a single entityType
         * @param {number} id 
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEntityType(id: number, data?: EntityType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntityType(id, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityTypeApi - factory interface
 * @export
 */
export const EntityTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityTypeApiFp(configuration)
    return {
        /**
         * 
         * @summary creates a single entityType
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntityType(data?: EntityType, options?: any): AxiosPromise<EntityType> {
            return localVarFp.createEntityType(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary enable/disable a single entityType
         * @param {number} id 
         * @param {boolean} enabled 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableEntityType(id: number, enabled: boolean, version?: number, options?: any): AxiosPromise<EntityType> {
            return localVarFp.enableEntityType(id, enabled, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEntityTypes(options?: any): AxiosPromise<Array<EntityType>> {
            return localVarFp.getAdminEntityTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCountByEntityType(id: number, options?: any): AxiosPromise<number> {
            return localVarFp.getEntityCountByEntityType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a single entityType
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityType(id: number, options?: any): AxiosPromise<EntityType> {
            return localVarFp.getEntityType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets the entity type features available
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypeFeatures(options?: any): AxiosPromise<Array<EntityTypeFeatureWithStorageType>> {
            return localVarFp.getEntityTypeFeatures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the entity types for the navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTypes(options?: any): AxiosPromise<Array<EntityType>> {
            return localVarFp.getEntityTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets the time frame for an entity type.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSeriesTimeFrame(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.getTimeSeriesTimeFrame(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {{ [key: string]: number; }} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAdminEntityTypes(entities?: { [key: string]: number; }, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.orderAdminEntityTypes(entities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a list / single of entityTypes
         * @param {Array<EntityOrderMap>} [entities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderEntityTypes(entities?: Array<EntityOrderMap>, options?: any): AxiosPromise<Array<EntityOrderMap>> {
            return localVarFp.orderEntityTypes(entities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates assumption entity type associations
         * @param {number} entityType 
         * @param {AssumptionEntityTypeAssocRequest} [assumptionEntityTypeAssocRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssumptionEntityTypeAssocs(entityType: number, assumptionEntityTypeAssocRequest?: AssumptionEntityTypeAssocRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateAssumptionEntityTypeAssocs(entityType, assumptionEntityTypeAssocRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updates a single entityType
         * @param {number} id 
         * @param {EntityType} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntityType(id: number, data?: EntityType, options?: any): AxiosPromise<EntityType> {
            return localVarFp.updateEntityType(id, data, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityTypeApi - object-oriented interface
 * @export
 * @class EntityTypeApi
 * @extends {BaseAPI}
 */
export class EntityTypeApi extends BaseAPI {
    /**
     * 
     * @summary creates a single entityType
     * @param {EntityType} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public createEntityType(data?: EntityType, options?: any) {
        return EntityTypeApiFp(this.configuration).createEntityType(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary enable/disable a single entityType
     * @param {number} id 
     * @param {boolean} enabled 
     * @param {number} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public enableEntityType(id: number, enabled: boolean, version?: number, options?: any) {
        return EntityTypeApiFp(this.configuration).enableEntityType(id, enabled, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the entity types for the navigator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getAdminEntityTypes(options?: any) {
        return EntityTypeApiFp(this.configuration).getAdminEntityTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a single entityType
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getEntityCountByEntityType(id: number, options?: any) {
        return EntityTypeApiFp(this.configuration).getEntityCountByEntityType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a single entityType
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getEntityType(id: number, options?: any) {
        return EntityTypeApiFp(this.configuration).getEntityType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets the entity type features available
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getEntityTypeFeatures(options?: any) {
        return EntityTypeApiFp(this.configuration).getEntityTypeFeatures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the entity types for the navigator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getEntityTypes(options?: any) {
        return EntityTypeApiFp(this.configuration).getEntityTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets the time frame for an entity type.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getTimeSeriesTimeFrame(id: number, options?: any) {
        return EntityTypeApiFp(this.configuration).getTimeSeriesTimeFrame(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a list / single of entityTypes
     * @param {{ [key: string]: number; }} [entities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public orderAdminEntityTypes(entities?: { [key: string]: number; }, options?: any) {
        return EntityTypeApiFp(this.configuration).orderAdminEntityTypes(entities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a list / single of entityTypes
     * @param {Array<EntityOrderMap>} [entities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public orderEntityTypes(entities?: Array<EntityOrderMap>, options?: any) {
        return EntityTypeApiFp(this.configuration).orderEntityTypes(entities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates assumption entity type associations
     * @param {number} entityType 
     * @param {AssumptionEntityTypeAssocRequest} [assumptionEntityTypeAssocRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public updateAssumptionEntityTypeAssocs(entityType: number, assumptionEntityTypeAssocRequest?: AssumptionEntityTypeAssocRequest, options?: any) {
        return EntityTypeApiFp(this.configuration).updateAssumptionEntityTypeAssocs(entityType, assumptionEntityTypeAssocRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updates a single entityType
     * @param {number} id 
     * @param {EntityType} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public updateEntityType(id: number, data?: EntityType, options?: any) {
        return EntityTypeApiFp(this.configuration).updateEntityType(id, data, options).then((request) => request(this.axios, this.basePath));
    }
}
